export const API_URL =
  process.env.REACT_APP_API_URL ||
  'https://2cj0emie94.execute-api.ca-central-1.amazonaws.com/prod';

export const USER_POOL_ID =
  process.env.REACT_APP_USER_POOL_ID || 'ca-central-1_AYUVPkPjd';

export const USER_POOL_CLIENT_ID =
  process.env.REACT_APP_USER_POOL_CLIENT_ID || 'gbclprej8p4h435ocdet9gv9h';

export const LICENSE_API_URL =
  process.env.REACT_APP_LICENSE_API_URL ||
  'https://tordxsmwwh.execute-api.ca-central-1.amazonaws.com/prod';
